import { SHOW_NAV,NAV_SELECTED, USER_INFO,SHOW_CARE_BAR } from './mutation-types.js';
export default {
 [SHOW_CARE_BAR](context, value) {
	  context.commit(SHOW_CARE_BAR, value)
  },
  [SHOW_NAV](context, value) {
    context.commit(SHOW_NAV, value)
  },
  [NAV_SELECTED](context, value) {
    context.commit(NAV_SELECTED, value)
  },
  [USER_INFO](context, value) {
    window.local.save('user-info', value)
    context.commit(USER_INFO, value)
  }
}